module.exports = __webpack_public_path__ + "img/close.af39c3e8.svg";